import axios from 'axios';
const message = {
    
	actions: {
		processmessage(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Message/ProcessMessage', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {	                   									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},	
		getmessage({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Message/GetMessage?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getmessagebyid({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get('/Message/GetMessagebyId?Id='+Id+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getmessagebysearch({rootState},searchVal){
			return new Promise((resolve, reject) => {				
				axios.get('/Message/GetMessagebySearch?SearchItem='+searchVal+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default message